import { useEffect } from 'react';
import { useLayout } from '@/contexts/LayoutContext';
import { useTheme } from '@/contexts/ThemeContext';
import { getLayout5ThemeStyle } from './theme';

const WL5_THEME_KEYS = [
  '--wl5-accent',
  '--l5-accent',
  '--wl5-primary',
  '--wl5-secondary',
  '--wl5-button',
  '--wl5-title',
  '--wl5-text',
  '--wl5-muted',
  '--wl5-header',
  '--wl5-menu',
  '--wl5-accent-bg',
] as const;

/** Injeta variáveis WL5 no :root quando o layout 5 está ativo (evita reset por `.layout-5` aninhado). */
export function Layout5ThemeSync() {
  const { currentLayout } = useLayout();
  const { colors } = useTheme();

  useEffect(() => {
    const root = document.documentElement;
    const isLayout5 = currentLayout === 'layout-5';

    if (!isLayout5) {
      WL5_THEME_KEYS.forEach((key) => root.style.removeProperty(key));
      root.style.removeProperty('--full-banner-blur-tint');
      return;
    }

    const style = getLayout5ThemeStyle(colors);
    Object.entries(style).forEach(([key, value]) => {
      if (typeof value === 'string') {
        root.style.setProperty(key, value);
      }
    });
    root.style.setProperty('--full-banner-blur-tint', colors.menu);

    return () => {
      WL5_THEME_KEYS.forEach((key) => root.style.removeProperty(key));
      root.style.removeProperty('--full-banner-blur-tint');
    };
  }, [currentLayout, colors]);

  return null;
}
